import axios from 'axios'
import cookies from '../assets/js/cookies.js'
import { Message } from 'element-ui'
import router from '../router/index'
let that = this
// 创建 axios 实例
const service = axios.create({
    //   baseURL: process.env.baseUrl, // 固定url
    //   baseURL: "http://192.168.66.18:8101/api/", // 固定url
    //   baseURL: window.location.origin  + '/api/', // 动态获取url
    baseURL: 'https://search.newacademic.net/api/' //线上地址
})

// 请求拦截器
service.interceptors.request.use((config) => {
    // 动态设置请求头
    if (cookies.getCookie("token")) {
        config.headers.common = {
            Authorization: cookies.getCookie("token"),
        }
    }

    if (config.method === 'post') {
        config.data = {
            ...config.data,
            t: Date.parse(new Date())
        }
    } else if (config.method === 'get') {
        config.params = {
            ...config.params,
            t: Date.parse(new Date())
        }
    }
    return config
}, (err) => {
    return Promise.reject(err)
})

// 响应拦截器
service.interceptors.response.use((res) => {
    if (res.data.code == 1) {
        // 请求成功，正常返回
        return res.data
    } else if (res.data.code == -999) {
        // token存在但是仍旧报找不到token 跳转登录页
        if (cookies.getCookie("token") && res.data.message === 'Token not found') {
            // 如果已经重定向过，不再重定向
            console.warn('Detected potential redirect loop, stopping further redirects.');
            // 跳转login，添加一个标记参数
            router.replace({
                name: 'login',
            });
        } else {
            // token失效，清除cookie
            cookies.logoutClearCookie();
            // 获取当前页面地址
            let url = window.location.href;

            // 截取url中 #/ 后的地址
            var index = url.lastIndexOf("/#/");
            url = url.substring(index + 3, url.length);
            // 跳转login，添加一个标记参数
            router.replace({
                name: 'check',
                query: { url: url }
            });
        }
    } else {
        // 请求失败
        Message.error(res.data.message);
        return Promise.reject(res);
    }
}, (err) => {
    // 接口请求失败（404或500的情况）
    return Promise.reject(err)
})


export default service


// WEBPACK FOOTER //
// ./src/api/index.js